import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12 1.25q.08 0 .159.01l.05.009a1.3 1.3 0 0 1 .256.07q.03.011.061.024.054.025.106.055l.037.02q.066.042.129.09l.044.04a1 1 0 0 1 .119.118q.02.02.039.043v.005q.085.105.148.232l2.31 4.677c.199.403.585.683 1.03.749l5.166.756c.575.083.977.53 1.076 1.032.08.4-.043.836-.368 1.152l-3.735 3.637c-.323.315-.471.77-.395 1.214l.882 5.14a1.27 1.27 0 0 1-.437 1.216 1.31 1.31 0 0 1-1.423.134l-4.617-2.427a1.38 1.38 0 0 0-1.275 0l-4.617 2.428a1.3 1.3 0 0 1-.755.139 1.274 1.274 0 0 1-1.103-1.492l.88-5.137a1.37 1.37 0 0 0-.395-1.215l-3.735-3.636a1.28 1.28 0 0 1-.36-1.192 1.275 1.275 0 0 1 1.072-.995l5.162-.754a1.37 1.37 0 0 0 1.033-.75l2.31-4.68c.23-.466.688-.713 1.146-.712m1 16.518q.171.064.335.15l4.225 2.222-.806-4.703a2.87 2.87 0 0 1 .826-2.542l3.417-3.327-4.726-.692a2.87 2.87 0 0 1-2.159-1.57L13 5.054z" />
  </>
);

const StarHalf = Icon('star-half', svgContents);

export default StarHalf;
